import React, { useState } from "react";
import { Select, Space, InputNumber, Button, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import ReusableTable from "../../../../components/TableComponent";
import { MasterConfigs } from "../../../../interfaces/entity";
const { Option } = Select;

interface JobOpening {
    key: string;
    department: string;
    jobRole: string;
    experienceMin: number | undefined;
    experienceMax: number | undefined;
    openings: number | undefined;
}

const NewBudget = () => {
    const [jobOpenings, setJobOpenings] = useState<JobOpening[]>([]);

    const handleAddRow = () => {
        const newRow: JobOpening = {
            key: `${jobOpenings.length}`,
            department: "",
            jobRole: "",
            experienceMin: undefined,
            experienceMax: undefined,
            openings: undefined,
        };
        setJobOpenings([...jobOpenings, newRow]);
    };

    const handleDeleteRow = (key: string) => {
        setJobOpenings(jobOpenings.filter((row) => row.key !== key));
    };

    const handleChange = (key: string, field: keyof JobOpening, value: any) => {
        const updatedRows = jobOpenings.map((row) =>
            row.key === key ? { ...row, [field]: value } : row
        );
        setJobOpenings(updatedRows);
    };

    const columns = [
        {
            title: "Department",
            dataIndex: "department",
            render: (_: any, record: JobOpening) => (
                <Select
                    placeholder="Select Department"
                    style={{ width: "100%" }}
                    onChange={(value) => handleChange(record.key, "department", value)}
                >
                    <Option value="HR">HR</Option>
                    <Option value="Engineering">Engineering</Option>
                    <Option value="Marketing">Marketing</Option>
                </Select>
            ),
        },
        {
            title: "Job Role",
            dataIndex: "jobRole",
            render: (_: any, record: JobOpening) => (
                <Select
                    placeholder="Select Job Role"
                    style={{ width: "100%" }}
                    onChange={(value) => handleChange(record.key, "jobRole", value)}
                >
                    <Option value="Manager">Manager</Option>
                    <Option value="Developer">Developer</Option>
                    <Option value="Designer">Designer</Option>
                </Select>
            ),
        },
        {
            title: "Experience (Yrs)",
            dataIndex: "experience",
            render: (_: any, record: JobOpening) => (
                <Space>
                    <InputNumber
                        placeholder="Min"
                        style={{ width: "80px" }}
                        onChange={(value) =>
                            handleChange(record.key, "experienceMin", value)
                        }
                    />
                    <span>-</span>
                    <InputNumber
                        placeholder="Max"
                        style={{ width: "80px" }}
                        onChange={(value) =>
                            handleChange(record.key, "experienceMax", value)
                        }
                    />
                </Space>
            ),
        },
        {
            title: "No. of Openings",
            dataIndex: "openings",
            render: (_: any, record: JobOpening) => (
                <InputNumber
                    placeholder="Provide no. of Openings"
                    style={{ width: "100%" }}
                    onChange={(value) => handleChange(record.key, "openings", value)}
                />
            ),
        },
        {
            title: "Remove",
            dataIndex: "remove",
            render: (_: any, record: JobOpening) => (
                <Button
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={() => handleDeleteRow(record.key)}
                />
            ),
        },
    ];

    const config: MasterConfigs = {
        modalTitle: (text) => `Add`,
        getColumns: () => columns
    }

    return (
        <div>
            {/* <Table
                dataSource={jobOpenings}
                columns={columns}
                pagination={false}
                bordered
            /> */}
            <ReusableTable config={config} dataSource={jobOpenings} />

            <Button
                type="link"
                icon={<PlusOutlined />}
                onClick={handleAddRow}
                style={{ marginTop: 16 }}
            >
                Add Job Openings
            </Button>
            <Button
                type="primary"
                style={{ marginTop: 16, float: "right" }}
                onClick={() => console.log("Estimate Budget:", jobOpenings)}
            >
                Estimate Budget
            </Button>
        </div>
    );
};



export default NewBudget;